import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=6075f1fc&"
import script from "./Basket.js?vue&type=script&lang=js&"
export * from "./Basket.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports